import SettingsIcon from "@mui/icons-material/Settings";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface SettingsPopupProps {
  onlyDrivers: boolean;
  setOnlyDrivers: (value: boolean) => void;
  showArchived: boolean;
  setShowArchived: (value: boolean) => void;
  vehicleStatus: boolean;
  setVehicleStatus: (status: boolean) => void;
}

const SettingsPopup: React.FC<SettingsPopupProps> = ({
  onlyDrivers,
  setOnlyDrivers,
  showArchived,
  setShowArchived,
  vehicleStatus,
  setVehicleStatus,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const theme = useTheme();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const { t } = useTranslation();
  return (
    <>
      <IconButton onClick={handleClick}>
        <SettingsIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: { width: "250px" },
        }}
      >
        <Box p={2}>
          <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600 }}>
            {t("user")}
          </Typography>

          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={onlyDrivers}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    setOnlyDrivers(event.target.checked)
                  }
                />
              }
              label={t("logbookEdit.onlyDrivers")}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={showArchived}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    setShowArchived(event.target.checked)
                  }
                />
              }
              label={t("logbookEdit.showArchived")}
            />
          </FormGroup>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ fontWeight: 600, marginTop: theme.spacing(2) }}
          >
            {t("device")}
          </Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={vehicleStatus}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    setVehicleStatus(event.target.checked)
                  }
                />
              }
              label={t("logbookEdit.showArchived")}
            />
          </FormGroup>
        </Box>
      </Popover>
    </>
  );
};

export default SettingsPopup;
